module.exports = __webpack_public_path__ + "static/media/play.4874ec73.svg";